export const Routes = {
  // pages
  test: { path: "/test" },
  Presentation: { path: "/" },
  DashboardOverview: { path: "/dashboard/overview" },
  Transactions: { path: "/transactions" },
  Settings: { path: "/settings" },
  Upgrade: { path: "/upgrade" },
  BootstrapTables: { path: "/tables/bootstrap-tables" },
  Billing: { path: "/examples/billing" },
  Invoice: { path: "/examples/invoice" },
  Signin: { path: "/sign-in" },
  Signup: { path: "/examples/sign-up" },
  ForgotPassword: { path: "/examples/forgot-password" },
  ResetPassword: { path: "/examples/reset-password" },
  Lock: { path: "/examples/lock" },
  NotFound: { path: "/examples/404" },
  ServerError: { path: "/examples/500" },

  Profile: { path: "/profile" },

  //collectors
  ViewCollectors: { path: "/collectors/view" },
  AddCollectors: { path: "/collectors/add" },
  CollectorsDetail: { path: "/collectors/profile/:id" },
  EditCollectors: { path: "/collectors/edit/:id" },

  //customers
  ViewCustomers: { path: "/customers/view" },
  AssignCustomersBatch: { path: "/customers/view/batchassign" },
  AddCustomers: { path: "/customers/add" },

  CustomerDetail: { path: "/customers/profile/:id" },
  CustomerEdit: { path: "/customers/edit/:id" },
  CustomerTransactionDetail: { path: "/customers/transaction/detail/:id" },
  CustomerProfileTransactionActive: {
    path: "/customers/profile/transactions/:id",
  },

  //sahakari
  ViewSahakari: { path: "/sahakari/view" },
  AddSahakari: { path: "/sahakari/add" },
  SahakariDetails: { path: "/sahakari/profile/:id" },
  SahakariEdit: { path: "/sahakari/edit/:id" },
  AddSahakariCustomers: { path: "/sahakari/addcustomers" },

  //batch
  ViewBatch: { path: "/batch/view" },
  ViewBatchDate: { path: "/batch/view/:date" },
  ViewBatchTransaction: { path: "/batch/transaction/:id" },

  //Notifications
  ViewUnassignedCustomers: { path: "/notification/unassignedcustomers" },
  ViewWithdrwalRequests: { path: "/notification/withdrawlrequests" },
  ViewPendingBatches: { path: "/notification/pendingbatches" },
  ViewInitBatches: { path: "/notification/initbatches" },
  //Transactions
  // SelectTransactionDate: { path: "/transactions/select" },
  ViewTransactions: { path: "/transactions/view/:date" },
  TransactionViewBatch: { path: "/transactions/view/batch/:date" },
  ViewTransactionsByBatchId: { path: "/transactions/batch/:id" },
  ViewTodaysTransaction: { path: "/transactions/today" },
  ViewTodaysBatches: { path: "/transactions/batches/today" },

  // docs
  DocsOverview: { path: "/documentation/overview" },
  DocsDownload: { path: "/documentation/download" },
  DocsQuickStart: { path: "/documentation/quick-start" },
  DocsLicense: { path: "/documentation/license" },
  DocsFolderStructure: { path: "/documentation/folder-structure" },
  DocsBuild: { path: "/documentation/build-tools" },
  DocsChangelog: { path: "/documentation/changelog" },

  // components
  Accordions: { path: "/components/accordions" },
  Alerts: { path: "/components/alerts" },
  Badges: { path: "/components/badges" },
  Widgets: { path: "/widgets" },
  Breadcrumbs: { path: "/components/breadcrumbs" },
  Buttons: { path: "/components/buttons" },
  Forms: { path: "/components/forms" },
  Modals: { path: "/components/modals" },
  Navs: { path: "/components/navs" },
  Navbars: { path: "/components/navbars" },
  Pagination: { path: "/components/pagination" },
  Popovers: { path: "/components/popovers" },
  Progress: { path: "/components/progress" },
  Tables: { path: "/components/tables" },
  Tabs: { path: "/components/tabs" },
  Tooltips: { path: "/components/tooltips" },
  Toasts: { path: "/components/toasts" },
  WidgetsComponent: { path: "/components/widgets" },
};
